import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import HomeWorkIcon from '@mui/icons-material/HomeWork';

const solutionData = {
  id: 'cadastral-survey',
  name: 'Cadastral Survey',
  icon: <HomeWorkIcon sx={{ fontSize: 60 }} />,
  description: 'Professional land boundary surveys and property mapping services',
  overview: `Our Cadastral Survey services provide accurate determination and documentation of property boundaries and land ownership. We utilize modern surveying equipment and techniques to deliver precise measurements and detailed property maps. Our experienced surveyors ensure compliance with local regulations and standards while providing comprehensive documentation for legal and administrative purposes.`,
  features: [
    {
      title: 'Boundary Surveys',
      description: 'Precise determination of property boundaries',
    },
    {
      title: 'Title Surveys',
      description: 'Detailed surveys for property titles and registration',
    },
    {
      title: 'Subdivision Planning',
      description: 'Survey services for land subdivision and development',
    },
    {
      title: 'Property Mapping',
      description: 'Creation of detailed property maps and plans',
    },
    {
      title: 'Legal Documentation',
      description: 'Preparation of survey reports and legal documents',
    },
    {
      title: 'Dispute Resolution',
      description: 'Professional support for boundary dispute resolution',
    },
  ],
  benefits: [
    'Accurate property boundaries',
    'Legal compliance',
    'Clear property documentation',
    'Professional expertise',
    'Modern survey technology',
    'Reliable reference data',
  ],
};

const CadastralSurvey = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default CadastralSurvey; 